import React from "react";

const ChangeSetDisplayComp = (props) => {
    const ignoredProperty = props.ignoredProperty ?? "";
    return (
        <>
            {props.changeSet && props.changeSet.length > 0 &&
                <ul className="note-list">
                    <div className="title-text">Change History</div>
                    {props.changeSet.map((item, idx) => (
                        <li key={idx}>
                            <div>
                                <div className="note-item">
                                    <div className="note-header">
                                        <span className="note-time">
                                            {item.changeTime}
                                        </span>
                                        <span className="note-title strong">
                                            {item.user}
                                        </span>
                                    </div>
                                    <div className="note-body">
                                        {item.changes.filter(x => x.propName  !== ignoredProperty).map(it => {
                                            return (
                                                <div>{it.propName} changed FROM: {it.oldValue}&emsp; TO: {it.newValue}</div>
                                            )
                                        })
                                        }
                                    </div>
                                </div>
                            </div>
                        </li>

                    ))}
                </ul>
            }
        </>
    )
};

export default ChangeSetDisplayComp;